import { z } from 'zod';
/**
 * Schema for sign-out - requires session token
 */
export const signOutSchema = z.object({
    sessionToken: z.string().min(1, 'Session token is required'),
});
//# sourceMappingURL=sign-out.schema.js.map